import React from 'react';
import Information from "../../components/information/information";

const Introduction = () => {
  return (
    <div>
      <Information numScreen={1} numInformation={1} linkTo={"/researche"} speakerName={false}/>
    </div>
  );
};

export default Introduction;